import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useAuth } from 'context/AuthProvider.js';
import { httpClient } from 'helpers/HttpClient.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { Controller, useForm } from 'react-hook-form';
const URIOperations = ApiEndpoint + 'operations/';
const URIConfig = ApiEndpoint + 'configuration/';
const EditConsumidorData = ({
  idQueja,
  queja,
  setErrorMesagge,
  setShowErrorMessage,
  setIsError,
  closeModal
}) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [generos, setGeneros] = useState(null);

  const {
    formState: { errors },
    control,
    handleSubmit,
    setValue
  } = useForm({
    defaultValues: {
      nombre: '',
      telefono: 0,
      email: 0,
      idGenero: 0
    }
  });
  const getGeneros = async () => {
    setGeneros(null);

    httpClient('GET', URIConfig + 'statusbytype/' + 8, {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var customersList = response.data.map(item => {
            return { value: item.idstatus, label: item.descripcion };
          });
          setGeneros(customersList);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getQuejaConsumidor = async () => {
    if (queja) {
      console.log('queja', queja);
      setValue('nombre', queja.nombreconsumidor);
      setValue('idGenero', queja.idstatusgenero);
      setValue('telefono', queja.tel1);
      setValue('email', queja.email);
    }
  };

  useEffect(() => {
    if (!generos) getGeneros();
    getQuejaConsumidor();
  }, []);
  const onSubmit = data => {
    console.log(data);
    httpClient(
      'POST',
      URIOperations + 'updateConsumidorData/' + idQueja,
      { data },
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          closeModal();
          setIsError(false);
          setErrorMesagge('Expediente Actualizado con exito');
          setShowErrorMessage(true);
        } else {
          setIsError(true);
          setErrorMesagge('Ha ocurrido un error al registrar el cierre');
          setShowErrorMessage(true);
        }
      })
      .catch(function (error) {
        console.log(error);
        setIsError(true);
        setErrorMesagge('Ha ocurrido un error al registrar el cierre');
        setShowErrorMessage(true);
      })
      .finally(() => {});
  };
  return (
    <>
      <Card style={{ width: '100%' }}>
        <Card.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="g-2 mb-3">
              <Col>
                <Controller
                  name="nombre"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <Form.Group>
                      <Form.Label>Nombre</Form.Label>
                      <Form.Control
                        type={'text'}
                        placeholder={'nombre'}
                        name="nombre"
                        {...field}
                        isInvalid={!!errors.nombre}
                        isValid={
                          Object.keys(errors).length > 0 && !errors.nombre
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.nombre?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  )}
                />
              </Col>
            </Row>
            <Row className="g-2 mb-3">
              <Col>
                <Controller
                  name="telefono"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <Form.Group>
                      <Form.Label>Telefono</Form.Label>
                      <Form.Control
                        type={'text'}
                        placeholder={'telefono'}
                        name="telefono"
                        {...field}
                        isInvalid={!!errors.telefono}
                        isValid={
                          Object.keys(errors).length > 0 && !errors.telefono
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.telefono?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  )}
                />
              </Col>
            </Row>
            <Row className="g-2 mb-3">
              <Col>
                <Controller
                  name="email"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <Form.Group>
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type={'text'}
                        placeholder={'email'}
                        name="email"
                        {...field}
                        isInvalid={!!errors.email}
                        isValid={
                          Object.keys(errors).length > 0 && !errors.email
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.email?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  )}
                />
              </Col>
            </Row>
            <Row className="g-2 mb-3">
              {generos && (
                <>
                  <Controller
                    name="idGenero"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Form.Group>
                        <Form.Label>Genero</Form.Label>
                        <Form.Select
                          type="select"
                          name="idGenero"
                          value={field.value}
                          onChange={field.onChange}
                          isInvalid={!!errors.idGenero}
                          isValid={
                            Object.keys(errors).length > 0 && !errors.idGenero
                          }
                        >
                          <option value="">Selecciona un genero</option>
                          {generos.map(option => (
                            <option value={option.value} key={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.idGenero?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    )}
                  />
                </>
              )}
            </Row>

            <Row>
              <Col>
                <Button type="submit" color="primary" size="sm">
                  Guardar
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
    </>
  );
};
EditConsumidorData.propTypes = {
  idQueja: PropTypes.number.isRequired,
  closeModal: PropTypes.func,
  setErrorMesagge: PropTypes.func,
  setShowErrorMessage: PropTypes.func,
  setIsError: PropTypes.func,
  queja: PropTypes.object
};

export default EditConsumidorData;
